import React, { useRef } from 'react';
import { StyledAlert, StyledCustomDialog, StyledIconButton, StyledInner, StyledLayoutContainer, StyledOverlay } from '../index.styles.js';
import {} from '../index.js';
import { pickDataProps } from '../../../utils/pick-data-props.js';
import { pickA11yProps } from '../../../utils/pick-a11y-props.js';
import { useFocusTrap } from '../../../utils/use-focus-trap.js';
export const DialogCustom = ({ children, padding = true, open, triggerButton, variant, dialogAriaProps, onCloseButtonAriaLabel, onCloseButtonClick, onClose, className, hasCloseButton, ...rest }) => {
    const ref = useRef(null);
    const triggerRef = useRef(null);
    const spreadRoleProp = pickA11yProps(rest)['role'];
    // TODO: Remove handleClose and replace it with the onClose prop once onCloseButtonClick has been removed
    const handleClose = () => {
        if (onCloseButtonClick) {
            onCloseButtonClick();
        }
        if (onClose) {
            onClose();
        }
    };
    useFocusTrap({
        open,
        ref,
        triggerRef
    });
    return (React.createElement(React.Fragment, null,
        triggerButton && React.cloneElement(triggerButton, { ref: triggerRef }),
        open && (React.createElement(React.Fragment, null,
            React.createElement(StyledOverlay, { onClick: handleClose, "aria-hidden": true }),
            React.createElement(StyledCustomDialog, { ...pickDataProps(rest), ...pickA11yProps(rest), ref: ref, "aria-describedby": dialogAriaProps?.ariaDescribedBy, "aria-labelledby": dialogAriaProps?.ariaLabelledBy, variant: variant, hasPadding: padding, className: className, role: spreadRoleProp || 'dialog' }, variant === 'alert' ? (React.createElement(StyledAlert, { hasPadding: padding }, children)) : (React.createElement(StyledLayoutContainer, null,
                hasCloseButton && (React.createElement(StyledIconButton, { "aria-label": onCloseButtonAriaLabel, variant: "tertiary", icon: "cancel", onClick: handleClose, size: "sm" })),
                React.createElement(StyledInner, { hasPadding: padding, variant: variant }, children))))))));
};
//# sourceMappingURL=custom.js.map